import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { Processor } from "../core/model/processor";
import { AuthService } from "./auth.service";
import { ErrorHandlerService } from './error-handler.service';
import axios from "axios";
import { AxiosInstance } from "axios";
import { isUndefined } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private getCurrentCustomerUrl = `${environment.apiUrl}/get-customers`;
  private downloadCustomersUrl = `${environment.apiUrl}/download-customers`;
  private createCustomerUrl = `${environment.apiUrl}/iso`;
  private createSubIsoCustomerUrl = `${environment.apiUrl}/sub-iso`;
  public getProcessorUrl = `${environment.apiUrl}/processors`;
  getEmail = `${environment.apiUrl}/getE/`;
  getIsoIdentifier = `${environment.apiUrl}/getIsoIdentifier/`;
  customerById = `${environment.apiUrl}/getCustomer/`;
  getCustomerInfo = `${environment.apiUrl}/getCustomerInfo/`;
  getSideBarImage = `${environment.apiUrl}/getSidebarImage/`;
  getContractTemplate = `${environment.apiUrl}/getContract/`;
  getContractIso = `${environment.apiUrl}/getContractMaster/`;
  addContract = `${environment.apiUrl}/addContract/`;
  calculateISOMonthlyBillingSummary = `${environment.apiUrl}/calculateISOMonthlyBillingSummary`;
  calculateAssetProtectionBilling = `${environment.apiUrl}/calculateAssetProtectionBilling`;
  calculate3DSecureBilling = `${environment.apiUrl}/calculate3DSecureBilling`;
  public calculateRentalISOMonthlyBillingSummary = `${environment.apiUrl}/generateRentalInvoice`;
  getselectedInvoiceIso = `${environment.apiUrl}/getselectedInvoiceIso`;
  getSalesPeron = `${environment.apiUrl}/customers/getSalesPersons`;
  isoPreferenceDataById = `${environment.apiUrl}/getIsoPreferenceList/`

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) { }

  getAllData(httpReqUrl): Observable<Processor[]> {
    return this.httpClient.get<Processor>(httpReqUrl).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError(this.handleError)
    );
  }

  getSalesPersons(term:string):Observable<any>{
    
    return this.httpClient.get(`${this.getSalesPeron}`,{params:{queryString:term}}).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError(this.handleError)
    );
  }

  getAllCustomersByCustomerId(body: any) {
    return this.httpClient.post(this.getCurrentCustomerUrl, body).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  downloadCustomers(body: any) {
    return this.httpClient.post(this.downloadCustomersUrl, body).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    );
  }

  createIsoCustomer(data) {
    return this.httpClient.post(this.createCustomerUrl, data).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    )
  }

  createSubIsoCustomer(data) {
    
    return this.httpClient.post(this.createSubIsoCustomerUrl, data).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError)
    )
  }

  handleError(error) {
    let errorMessage = {};
    if (error.error instanceof ErrorEvent) {
      errorMessage["message"] = error.error.message;
    } else if (error.error.errors instanceof Array) {
      return throwError({errors:error.error.errors});
    } else if(error.error.error.message.error){
      errorMessage["status"] = "Double Extensions";
      errorMessage["message"] = "File has multiple Extensions Please Change File Name"
    } else{
      errorMessage["status"] = error.status;
      errorMessage["message"] = error.error.message
        ? error.error.message
        : error.message;
    }
    return throwError(errorMessage);
  }

  get_Parameters(httpReqUrl, parameter) {

    if(isUndefined(parameter.isoIdentified)){
      httpReqUrl = httpReqUrl + parameter.email
    }    
    if(!isUndefined(parameter.isoIdentified)){
      httpReqUrl = httpReqUrl + parameter.isoIdentified
    }
      return this.httpClient.get(httpReqUrl).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError(this.handleError)
    );
  }

  getCustomerById(httpReqUrl, parameter) {
    httpReqUrl = httpReqUrl + parameter.customerId;
     return this.httpClient.get(httpReqUrl).pipe(
       map((res: any) => {
         return res.data;
       }),
       catchError(this.handleError)
     );
 }
}
